import React, { useEffect, useMemo, useState } from 'react';
import useContactUsStore from '../../Store/contactUs';
import useLandingStore from '../../Store/Landing';
import LoadingBox from '../Common/LoadingBox';
import Branches from '../Branches';
import { StyledDiv, StyledSpan } from '../../Theme/CommonStyled';
import BrandContainerWithLogo from '../Common/BrandContainerWithLogo';
import ContactUsTile from '../Common/ContactUsTile';
import { useTranslation } from 'react-i18next';
import { StyledPhoneContainer, StyledPhoneNumber } from './style';
import Icon from '../Common/Icon';
import { StyledAddressContainer } from './style';
import OpenTime from '../Home/OpenTime';
import Title from '../Common/Title';
import { StyledSloganContainer } from '../Branches/BranchActionSheet/style';
import NavigationModal from '../Common/NavigationModal';

const ContactUs: React.FC = () => {
  const { t } = useTranslation();

  const contactUsData = useContactUsStore((store) => store.contactUsData);
  const contactUsLoading = useContactUsStore((store) => store.contactUsLoading);
  const getContactUsDataAction = useContactUsStore(
    (store) => store.getContactUsDataAction
  );
  const landingData = useLandingStore((store) => store.landingData);

  const [openNavigationModal, setOpenNavigationModal] = useState(false);

  useEffect(() => {
    !contactUsData && getContactUsDataAction(landingData.uniqueId);
  }, []);

  const branchData = useMemo(
    () => contactUsData && contactUsData?.length === 1 && contactUsData[0],
    [contactUsData]
  );

  return (
    <LoadingBox loading={contactUsLoading} skeletonType="brand">
      <StyledDiv
        px={8}
        pt={contactUsData?.length === 1 ? '100px' : 0}
        direction="rtl">
        {contactUsData?.length > 1 ? (
          <Branches />
        ) : (
          <>
            <NavigationModal
              openModal={openNavigationModal}
              setOpenModal={setOpenNavigationModal}
              branchData={branchData?.contactUsViewModel}
            />
            <BrandContainerWithLogo
              logo={branchData?.logoUrl}
              brandName={branchData?.branchName}>
              <StyledDiv
                display="grid"
                gridTemplateColumns={`repeat(3, 1fr )`}
                gridGap="10px">
                <ContactUsTile
                  href={branchData?.contactUsViewModel.webSite}
                  target={'_blank'}
                  disabled={!branchData?.contactUsViewModel.webSite}
                  icon="language"
                  title={t('global.site')}
                />
                <ContactUsTile
                  href={`https://instagram.com/${branchData?.contactUsViewModel.instagram}/`}
                  target={'-blank'}
                  disabled={!branchData?.contactUsViewModel.instagram}
                  icon="instagram"
                  title={t('global.instagram')}
                />
                <ContactUsTile
                  icon="menu_1"
                  href={branchData?.contactUsViewModel.digitalMenuUrl}
                  disabled={!branchData?.contactUsViewModel.digitalMenuUrl}
                  target={'-blank'}
                  title={t('global.menu')}
                />
              </StyledDiv>
            </BrandContainerWithLogo>
            {branchData?.contactUsViewModel.branchPhone && (
              <StyledPhoneContainer>
                <StyledDiv>
                  <Icon name="phone_1" color="secondaryText" fontSize={14} />
                  <StyledSpan mr={7} color="normalText" fontSize={4}>
                    {t('global.phone')}
                  </StyledSpan>
                </StyledDiv>
                <StyledPhoneNumber
                  href={`tel:${branchData?.contactUsViewModel.branchPhone}`}>
                  {branchData?.contactUsViewModel.branchPhone}
                </StyledPhoneNumber>
              </StyledPhoneContainer>
            )}
            {branchData?.contactUsViewModel.address && (
              <StyledAddressContainer>
                <StyledDiv display="flex" alignItems="center" mb={7}>
                  <Icon
                    name="location"
                    color="secondaryText"
                    fontSize={14}
                    ml={7}
                  />
                  <StyledDiv textAlign="right" fontSize={2} color="normalText">
                    {branchData?.contactUsViewModel.address}
                  </StyledDiv>
                </StyledDiv>
                <StyledSpan
                  fontSize={4}
                  color="primaryBlue"
                  cursor="pointer"
                  width="fit-content"
                  onClick={() => {
                    setOpenNavigationModal(true);
                  }}>
                  {t('branches.navigation')}
                </StyledSpan>
              </StyledAddressContainer>
            )}
            {!!branchData?.contactUsViewModel.openTimes?.length && (
              <OpenTime
                openTimes={branchData?.contactUsViewModel.openTimes}
                titleMargin={1}
                bg="secondaryBackground"
              />
            )}
            {branchData?.contactUsViewModel.slogan && (
              <>
                <Title title={t('landing.slogan')} mt={8} mb={6} />
                <StyledSloganContainer mb={12}>
                  {branchData?.contactUsViewModel.slogan}
                </StyledSloganContainer>
              </>
            )}
          </>
        )}
      </StyledDiv>
    </LoadingBox>
  );
};

export default ContactUs;
